/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
 */
export interface GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
     */
    'reasons'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
     */
    'result'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInner
     */
    'state'?: GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum;
}

export const GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum = {
    approved: 'APPROVED',
    denied: 'DENIED'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerResultEnum];
export const GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum = {
    accepted: 'ACCEPTED',
    plansSelected: 'PLANS_SELECTED',
    inProgress: 'IN_PROGRESS',
    verified: 'VERIFIED'
} as const;

export type GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum = typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum[keyof typeof GetOnboardingRequestById200ResponseIdentityVerificationInnerRecordsInnerStateEnum];


